import { BaseRequest, IBaseRequest } from '../../BaseRequest';

export interface IListTransactionRequest extends IBaseRequest {
  timestamp?: string;
  limit?: number;
  offset?: number;
  orderBy?: string;
  orderByType?: string;
  account?: string;
  activity?: string;
  attrib0?: string;
  attrib0_id?: number;
  attrib1?: string;
  attrib1_id?: number;
  attrib2?: string;
  attrib2_id?: number;
  attrib3?: string;
  attrib3_id?: number;
  attrib4?: string;
  attrib4_id?: number;
  attrib5?: string;
  attrib5_id?: number;
  attrib6?: string;
  attrib6_id?: number;
  attrib7?: string;
  attrib7_id?: number;
  attrib8?: string;
  attrib8_id?: number;
  attrib9?: string;
  attrib9_id?: number;
  bookkeepingAmount?: number;
  bookkeepingUnitPrice?: number;
  bookkeepingCurrency?: string;
  bookkeepingCurrencyRate?: number;
  catalogPrice?: number;
  created?: string;
  createdBy?: string;
  customId?: string;
  transactionDate?: string;
  description?: string;
  direction?: string;
  entry?: string;
  childKey?: string;
  id?: number;
  item?: string;
  itemComponentCategory?: string;
  itemDescription?: string;
  itemQuantity?: number;
  itemSerial?: string;
  journal?: string;
  modified?: string;
  modifiedBy?: string;
  otherAmount?: number;
  otherUnitPrice?: number;
  otherCurrency?: string;
  otherCurrencyRate?: number;
  ordertrn?: string;
  parent?: string;
  parentKey?: string;
  project?: string;
  folder?: string;
  type?: string;
  userId?: string;
  VAT?: string;
  VATValue?: number;
  VATTitle?: string;
  voucher?: string;
  dimension1?: string;
  dimension1Name?: string;
  dimension2?: string;
  dimension2Name?: string;
  dimension3?: string;
  dimension3Name?: string;
  splitSwitch?: boolean;
  orderIndex?: number;
  pairingKey?: string;
  pairingSum?: number;
  itemRefId?: string;
}

export class ListTransactionRequest extends BaseRequest implements IListTransactionRequest {
  timestamp?: string;
  limit?: number;
  offset?: number;
  orderBy?: string;
  orderByType?: string;
  account?: string;
  activity?: string;
  attrib0?: string;
  attrib0_id?: number;
  attrib1?: string;
  attrib1_id?: number;
  attrib2?: string;
  attrib2_id?: number;
  attrib3?: string;
  attrib3_id?: number;
  attrib4?: string;
  attrib4_id?: number;
  attrib5?: string;
  attrib5_id?: number;
  attrib6?: string;
  attrib6_id?: number;
  attrib7?: string;
  attrib7_id?: number;
  attrib8?: string;
  attrib8_id?: number;
  attrib9?: string;
  attrib9_id?: number;
  bookkeepingAmount?: number;
  bookkeepingUnitPrice?: number;
  bookkeepingCurrency?: string;
  bookkeepingCurrencyRate?: number;
  catalogPrice?: number;
  created?: string;
  createdBy?: string;
  customId?: string;
  transactionDate?: string;
  description?: string;
  direction?: string;
  entry?: string;
  childKey?: string;
  id?: number;
  item?: string;
  itemComponentCategory?: string;
  itemDescription?: string;
  itemQuantity?: number;
  itemSerial?: string;
  journal?: string;
  modified?: string;
  modifiedBy?: string;
  otherAmount?: number;
  otherUnitPrice?: number;
  otherCurrency?: string;
  otherCurrencyRate?: number;
  ordertrn?: string;
  parent?: string;
  parentKey?: string;
  project?: string;
  folder?: string;
  type?: string;
  userId?: string;
  VAT?: string;
  VATValue?: number;
  VATTitle?: string;
  voucher?: string;
  dimension1?: string;
  dimension1Name?: string;
  dimension2?: string;
  dimension2Name?: string;
  dimension3?: string;
  dimension3Name?: string;
  splitSwitch?: boolean;
  orderIndex?: number;
  pairingKey?: string;
  pairingSum?: number;
  itemRefId?: string;

  constructor(server: string, session: string, otherOptions?: Partial<IListTransactionRequest>) {
    super(server, session);
    if (otherOptions) {
      Object.assign(this, otherOptions);
    }
  }

  public toXml(): string {
    let parameters = super.toXml();
    parameters += this.makeNode(this.timestamp, 'timestamp');
    parameters += this.makeNode(this.limit, 'limit');
    parameters += this.makeNode(this.offset, 'offset');
    parameters += this.makeNode(this.orderBy, 'orderBy');
    parameters += this.makeNode(this.orderByType, 'orderByType');
    parameters += this.makeNode(this.account, 'account');
    parameters += this.makeNode(this.activity, 'activity');
    parameters += this.makeNode(this.attrib0, 'attrib0');
    parameters += this.makeNode(this.attrib0_id, 'attrib0_id');
    parameters += this.makeNode(this.attrib1, 'attrib1');
    parameters += this.makeNode(this.attrib1_id, 'attrib1_id');
    parameters += this.makeNode(this.attrib2, 'attrib2');
    parameters += this.makeNode(this.attrib2_id, 'attrib2_id');
    parameters += this.makeNode(this.attrib3, 'attrib3');
    parameters += this.makeNode(this.attrib3_id, 'attrib3_id');
    parameters += this.makeNode(this.attrib4, 'attrib4');
    parameters += this.makeNode(this.attrib4_id, 'attrib4_id');
    parameters += this.makeNode(this.attrib5, 'attrib5');
    parameters += this.makeNode(this.attrib5_id, 'attrib5_id');
    parameters += this.makeNode(this.attrib6, 'attrib6');
    parameters += this.makeNode(this.attrib6_id, 'attrib6_id');
    parameters += this.makeNode(this.attrib7, 'attrib7');
    parameters += this.makeNode(this.attrib7_id, 'attrib7_id');
    parameters += this.makeNode(this.attrib8, 'attrib8');
    parameters += this.makeNode(this.attrib8_id, 'attrib8_id');
    parameters += this.makeNode(this.attrib9, 'attrib9');
    parameters += this.makeNode(this.attrib9_id, 'attrib9_id');
    parameters += this.makeNode(this.bookkeepingAmount, 'bookkeepingAmount');
    parameters += this.makeNode(this.bookkeepingUnitPrice, 'bookkeepingUnitPrice');
    parameters += this.makeNode(this.bookkeepingCurrency, 'bookkeepingCurrency');
    parameters += this.makeNode(this.bookkeepingCurrencyRate, 'bookkeepingCurrencyRate');
    parameters += this.makeNode(this.catalogPrice, 'catalogPrice');
    parameters += this.makeNode(this.created, 'created');
    parameters += this.makeNode(this.createdBy, 'createdBy');
    parameters += this.makeNode(this.customId, 'customId');
    parameters += this.makeNode(this.transactionDate, 'transactionDate');
    parameters += this.makeNode(this.description, 'description');
    parameters += this.makeNode(this.direction, 'direction');
    parameters += this.makeNode(this.entry, 'entry');
    parameters += this.makeNode(this.childKey, 'childKey');
    parameters += this.makeNode(this.id, 'id');
    parameters += this.makeNode(this.item, 'item');
    parameters += this.makeNode(this.itemComponentCategory, 'itemComponentCategory');
    parameters += this.makeNode(this.itemDescription, 'itemDescription');
    parameters += this.makeNode(this.itemQuantity, 'itemQuantity');
    parameters += this.makeNode(this.itemSerial, 'itemSerial');
    parameters += this.makeNode(this.journal, 'journal');
    parameters += this.makeNode(this.modified, 'modified');
    parameters += this.makeNode(this.modifiedBy, 'modifiedBy');
    parameters += this.makeNode(this.otherAmount, 'otherAmount');
    parameters += this.makeNode(this.otherUnitPrice, 'otherUnitPrice');
    parameters += this.makeNode(this.otherCurrency, 'otherCurrency');
    parameters += this.makeNode(this.otherCurrencyRate, 'otherCurrencyRate');
    parameters += this.makeNode(this.ordertrn, 'ordertrn');
    parameters += this.makeNode(this.parent, 'parent');
    parameters += this.makeNode(this.parentKey, 'parentKey');
    parameters += this.makeNode(this.project, 'project');
    parameters += this.makeNode(this.folder, 'folder');
    parameters += this.makeNode(this.type, 'type');
    parameters += this.makeNode(this.userId, 'userId');
    parameters += this.makeNode(this.VAT, 'VAT');
    parameters += this.makeNode(this.VATValue, 'VATValue');
    parameters += this.makeNode(this.VATTitle, 'VATTitle');
    parameters += this.makeNode(this.voucher, 'voucher');
    parameters += this.makeNode(this.dimension1, 'dimension1');
    parameters += this.makeNode(this.dimension1Name, 'dimension1Name');
    parameters += this.makeNode(this.dimension2, 'dimension2');
    parameters += this.makeNode(this.dimension2Name, 'dimension2Name');
    parameters += this.makeNode(this.dimension3, 'dimension3');
    parameters += this.makeNode(this.dimension3Name, 'dimension3Name');
    parameters += this.makeNode(this.splitSwitch, 'splitSwitch');
    parameters += this.makeNode(this.orderIndex, 'orderIndex');
    parameters += this.makeNode(this.pairingKey, 'pairingKey');
    parameters += this.makeNode(this.pairingSum, 'pairingSum');
    parameters += this.makeNode(this.itemRefId, 'itemRefId');
    return super.wrapperXml('ListTransaction', parameters);
  }
}
